import React, { useState, useEffect } from 'react';
import api from 'services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { addNotification } from 'actions/notifications/notifications';
import ControlButtons, { 
    sizesMap, deadWeightFieldsNamesMap, basicNamesFieldsMap, registerClassFieldsMap,
    rtFieldsNamesMap, capacityV2FieldsNamesMap, generateHatchTweenDeckStr,
    sizesFieldsNamesMap, techEquipCertificateFieldsNamesMap, CollapseBody, 
    transfer, dimensionsFieldsMap,
} from './utils';

function Collapses({ 
    sizes, vessel, getSizes, setModifySizes, addNotification,
    addToMultiTransfer, shouldGenerateCollapses, shouldShowApproveReject,
}) {
    const [collapses, setCollapses] = useState([]);
    const [sizesFieldsNames, __] = useState(sizesFieldsNamesMap);

    const transferOne = modification => transfer(modification, setModifySizes);

    const accept = (modification) => {
        const { 
            groupField, emailIds, field, sizes: _sizes, type,
        } = transferOne(modification);
        
        let sizeIds;
        if (groupField) {
            sizeIds = _sizes[type][groupField].map(v => v._id);
        }
        
        api.approveVesselSize(vessel._id, emailIds, field, sizeIds).then(() => {
            getSizes();
            addNotification({
                title: 'Success',
                message: 'Value applied and marked as approved',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        });
    };

    const reject = (params) => {
        const {
            emailIds, type, sizes: _sizes, field, reason, 
        } = params;
        let sizeIds;
        if (field) {
            sizeIds = _sizes[type][field].map(v => v._id);
        }

        api.rejectVesselSize(vessel._id, emailIds, sizesFieldsNames[type], sizeIds, reason)
            .then(() => {
                // TODO: set error notification here
                getSizes();
                addNotification({
                    title: 'Success',
                    message: 'Value declined and removed',
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
            });
    };

    useEffect(() => {
        setCollapses([]);
        if (!shouldGenerateCollapses) return;
        setCollapses(generateCollapseList({
            sizes, techEquipCertificateFieldsNamesMap, shouldShowApproveReject, capacityV2FieldsNamesMap,
        }));
        return () => {
            setCollapses([]);
        }
    }, [sizes]);

    function generateCollapseList({sizes, techEquipCertificateFieldsNamesMap, shouldShowApproveReject, capacityV2FieldsNamesMap}) {
        const collapsesData = [];
        const {
            grouppedByTypeByPurpose, grouppedByTypeByConstruction, grouppedByTypeBySpecialty,
            grouppedByTechEquipCertificate, grouppedByDeadWeight, grouppedByRt,
            grouppedByGears, grouppedBySpeedConsumption, grouppedByBoxShaped, grouppedByOpenHatch,
            grouppedByCells, grouppedByHatches, grouppedByHolds, grouppedByCapacityV2,
            grouppedByFlags, grouppedByRegisterClass, grouppedByPIClub, grouppedByGrabs,
            grouppedByDimensions,
        } = sizes;
    
        if (grouppedByTypeByPurpose && Object.keys(grouppedByTypeByPurpose).length) {
            collapsesData.push({
                head: sizesMap.grouppedByTypeByPurpose,
                body: generateCollapseBody({
                    key: 'grouppedByTypeByPurpose',
                    nameValue: [{ name: sizesMap.grouppedByTypeByPurpose, value: 'typeByPurpose' }],
                    group: grouppedByTypeByPurpose,
                    type: 'string',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByTypeByConstruction && Object.keys(grouppedByTypeByConstruction).length) {
            collapsesData.push({
                head: sizesMap.grouppedByTypeByConstruction,
                body: generateCollapseBody({
                    key: 'grouppedByTypeByConstruction',
                    nameValue: [{ name: sizesMap.grouppedByTypeByConstruction, value: 'typeByConstruction' }],
                    group: grouppedByTypeByConstruction,
                    type: 'string',
                }, sizes, accept, reject, transferOne, status, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByTypeBySpecialty && Object.keys(grouppedByTypeBySpecialty).length) {
            collapsesData.push({
                head: sizesMap.grouppedByTypeBySpecialty,
                body: generateCollapseBody({
                    key: 'grouppedByTypeBySpecialty',
                    nameValue: [{ name: sizesMap.grouppedByTypeBySpecialty, value: 'typeBySpecialty' }],
                    group: grouppedByTypeBySpecialty,
                    type: 'string',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByBoxShaped && Object.keys(grouppedByBoxShaped).length) {
            collapsesData.push({
                head: sizesMap.grouppedByBoxShaped,
                body: generateCollapseBody({
                    key: 'grouppedByBoxShaped',
                    nameValue: [{ name: sizesMap.grouppedByBoxShaped, value: 'boxShaped' }],
                    group: grouppedByBoxShaped,
                    type: 'string',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByOpenHatch && Object.keys(grouppedByOpenHatch).length) {
            collapsesData.push({
                head: sizesMap.grouppedByOpenHatch,
                body: generateCollapseBody({
                    key: 'grouppedByOpenHatch',
                    nameValue: [{ name: sizesMap.grouppedByOpenHatch, value: 'openHatch' }],
                    group: grouppedByOpenHatch,
                    type: 'string',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByGears && Object.keys(grouppedByGears).length) {
            collapsesData.push({
                head: sizesMap.grouppedByGears,
                body: generateCollapseBody({
                    key: 'grouppedByGears',
                    nameValue: [
                        { name: 'Type', value: 'type' },
                        { name: 'Quantity', value: 'quantity' },
                        { name: 'Capacity', value: 'capacity' },
                        { name: 'Max SWL', value: 'maxSWL' },
                    ],
                    group: grouppedByGears,
                    type: 'array',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }

        if (grouppedByGrabs && Object.keys(grouppedByGrabs).length) {
            collapsesData.push({
                head: sizesMap.grouppedByGrabs,
                body: generateCollapseBody({
                    key: 'grouppedByGrabs',
                    nameValue: [
                        { name: 'Type', value: 'type' },
                        { name: 'Quantity', value: 'quantity' },
                        { name: 'Volume', value: 'volume' },
                    ],
                    group: grouppedByGrabs,
                    type: 'array',
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedBySpeedConsumption && Object.keys(grouppedBySpeedConsumption).length) {
            collapsesData.push({
                head: sizesMap.grouppedBySpeedConsumption,
                body: ( 
                    <div>
                        { Object.entries(grouppedBySpeedConsumption).map((g, index) => {
                            const value = g[1];
                            return (
                                <div key={`grouppedBySpeedConsumption_${g[0]}`} className='row'>
                                    <div className='col-xs-6'>
                                        <p>
                                            <b>Mode:</b> { value[0].mode }&nbsp;&nbsp;&nbsp;
                                            { value[0].speed && <span><b>Speed:</b> {value[0].speed}</span> }&nbsp;&nbsp;&nbsp;
                                            { 
                                                value[0].ifo && 
                                                <React.Fragment>
                                                    <span><b>Ifo:</b> {value[0].ifo.typeIfo}</span>&nbsp;&nbsp;&nbsp;
                                                    <span><b>Cons:</b> {value[0].ifo.cons}</span>&nbsp;&nbsp;&nbsp;
                                                </React.Fragment>
                                            }
                                            { 
                                                value[0].mdo && 
                                                <React.Fragment>
                                                    <span><b>Mdo:</b> {value[0].mdo.typeMdo}</span>&nbsp;&nbsp;&nbsp; 
                                                    <span><b>Cons:</b> {value[0].mdo.cons}</span>&nbsp;&nbsp;&nbsp;
                                                </React.Fragment>
                                            }
                                        </p>
                                    </div>
                                    <div className='col-xs-5'>
                                        { value.map(v => (
                                            <p style={{ display: 'inline-block' }}>
                                                <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                            </p>
                                        )) }
                                    </div>
                                    <div className='col-xs-1' style={{ padding: 0 }}>
                                        <ControlButtons 
                                            type='grouppedBySpeedConsumption'
                                            size={sizes && {
                                                speedConsumptionV2: {
                                                    value: sizes.grouppedBySpeedConsumption[g[0]][0],
                                                },
                                            }}
                                            sizes={sizes}
                                            field={g[0]}
                                            emailIds={value.map(v => v.emailId)}
                                            index={index}
                                            accept={accept}
                                            reject={reject}
                                            transfer={transferOne}
                                            addToMultiTransfer={addToMultiTransfer}
                                            shouldShowApproveReject={shouldShowApproveReject}
                                        />
                                    </div>
                                </div>
                            );
                        }) }
                    </div>
                ),
            });
        }
    
        if (grouppedByTechEquipCertificate && Object.keys(grouppedByTechEquipCertificate).length) {
            collapsesData.push({
                head: sizesMap.grouppedByTechEquipCertificate,
                body: (
                    <div>{
                        Object.entries(grouppedByTechEquipCertificate).map((g, index) => {
                            const values = g[1];
                            const techEntries = Object.entries(_.omit(values[0].techEquipCertificate.value, ['_id']));

                            return (
                                <div key={`grouppedByTechEquipCertificate_${g[0]}`} className='row'>
                                    <div className='col-xs-6'>
                                        <p>{
                                            techEntries.map((te, teIdex) => (
                                                <span 
                                                    id={`${te[0]}_${index}_${teIdex}`}
                                                    key={`${te[0]}_${index}_${teIdex}`}
                                                >
                                                    <b>{techEquipCertificateFieldsNamesMap[te[0]]}: </b>{te[1] === true ? 'true' : te[1]}&nbsp;&nbsp;&nbsp;
                                                </span>
                                            ))
                                        }
                                        </p>
                                    </div>
                                    <div className='col-xs-5'>
                                        { values.map(v => (
                                            <p style={{ display: 'inline-block' }}>
                                                <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                            </p>
                                        )) }
                                    </div>
                                    <div className='col-xs-1' style={{ padding: 0 }}>
                                        <ControlButtons 
                                            type='grouppedByTechEquipCertificate'
                                            size={sizes && sizes.grouppedByTechEquipCertificate[g[0]][0]}
                                            index={index}
                                            emailIds={values.map(v => v.emailId)}
                                            accept={accept}
                                            reject={reject}
                                            transfer={transferOne}
                                            addToMultiTransfer={addToMultiTransfer}
                                            shouldShowApproveReject={shouldShowApproveReject}
                                        />
                                    </div>
                                </div>
                            );
                        })
                    }
                    </div>
                ),
            });
        }
    
        if (grouppedByDeadWeight && Object.keys(grouppedByDeadWeight).length) {
            collapsesData.push({
                head: sizesMap.grouppedByDeadWeight,
                body: generateCollapseBody({
                    key: 'grouppedByDeadWeight',
                    group: grouppedByDeadWeight,
                    type: 'object',
                    namesMap: deadWeightFieldsNamesMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }

        if (grouppedByDimensions && Object.keys(grouppedByDimensions).length) {
            collapsesData.push({
                head: sizesMap.grouppedByDimensions,
                body: generateCollapseBody({
                    key: 'grouppedByDimensions',
                    group: grouppedByDimensions,
                    type: 'object',
                    namesMap: dimensionsFieldsMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByRt && Object.keys(grouppedByRt).length) {
            collapsesData.push({
                head: sizesMap.grouppedByRt,
                body: generateCollapseBody({
                    key: 'grouppedByRt',
                    group: grouppedByRt,
                    type: 'object',
                    namesMap: rtFieldsNamesMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByHatches && Object.keys(grouppedByHatches).length) {
            collapsesData.push({
                head: sizesMap.grouppedByHatches,
                body: generateCollapseBody({
                    key: 'grouppedByHatches',
                    group: grouppedByHatches,
                    type: 'object',
                    namesMap: { quantity: 'Quantity' },
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        if (grouppedByHolds && Object.keys(grouppedByHolds).length) {
            collapsesData.push({
                head: sizesMap.grouppedByHolds,
                body: generateCollapseBody({
                    key: 'grouppedByHolds',
                    group: grouppedByHolds,
                    type: 'object',
                    namesMap: { quantity: 'Quantity' },
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }

        if (grouppedByCapacityV2 && Object.keys(grouppedByCapacityV2).length) {
            collapsesData.push({
                head: sizesMap.grouppedByCapacityV2,
                body: (<div> {
                    Object.entries(grouppedByCapacityV2).map((g, index) => {
                        const value = g[1];
                        return (
                            <div key={`grouppedByCapacityV2_${g[0]}`} className='row'>
                                <div className='col-xs-6'>
                                    <p>{ _.sortBy(Object.entries(_.omit(value[0].capacityV2.value, ['_id'])), (e => e[0])).map(d => (
                                        <span key={`${d[0]}_${d[1]}`}>
                                            <b>{capacityV2FieldsNamesMap[d[0]]}: </b>{
                                                typeof d[1] === 'number' ?
                                                    <React.Fragment>
                                                        {d[1] + ''}&nbsp;&nbsp;&nbsp;
                                                    </React.Fragment> 
                                                    :
                                                    <React.Fragment><br />
                                                        <div>Holds:<br />
                                                            {
                                                                Object.keys(d[1][0]).length ? 
                                                                    d[1].map((summItem, sIndex) => {
                                                                        const items = Object.entries(summItem.hold);
                                                                        let elem = '';
                                                                        items.forEach((item) => {
                                                                            elem += `${capacityV2FieldsNamesMap[item[0]]}: ${item[1]} `;
                                                                        });

                                                                        return (
                                                                            <span id={`summItem_${sIndex}`}>
                                                                                {elem}<br />
                                                                            </span>
                                                                        );
                                                                    }) 
                                                                    : null
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                            }
                                        </span>
                                    ))}
                                    </p>
                                </div>
                                <div className='col-xs-5'>
                                    {
                                        value.map(v => (
                                            <p style={{ display: 'inline-block' }}>
                                                <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                            </p>
                                        ))
                                    }
                                </div>
                                <div className='col-xs-1' style={{ padding: 0 }}>
                                    <ControlButtons 
                                        type="grouppedByCapacityV2"
                                        size={sizes && sizes.grouppedByCapacityV2[g[0]][0]}
                                        emailIds={value.map(v => v.emailId)}
                                        index={index}
                                        accept={accept}
                                        reject={reject}
                                        transfer={transferOne}
                                        addToMultiTransfer={addToMultiTransfer}
                                        shouldShowApproveReject={shouldShowApproveReject}
                                    />
                                </div>
                            </div>
                        );
                    })
                } </div>),
            });
        }

        if (grouppedByCells && Object.keys(grouppedByCells).length) {
            collapsesData.push({
                head: sizesMap.grouppedByCells,
                body: (<div> {
                    Object.entries(grouppedByCells).map((g, index) => {
                        const values = g[1];
                        return (
                            <div key={`grouppedByCells_${g[0]}`} className='row'>
                                <div className='col-xs-6'>
                                    { values[0].cells.value.map((v, vIndex) => {
                                        const { holds, hatches, tweenDecks } = v;
                                        const fHolds = _.omit(holds, ['_id']);
                                        const fHatches = hatches.map(h => _.omit(h, ['_id']));
                                        const fTweenDecks = tweenDecks.map(t => _.omit(t, ['_id']));
                                            
                                        const hatchStr0 = generateHatchTweenDeckStr(fHatches[0]);
                                        const hatchStr1 = generateHatchTweenDeckStr(fHatches[1]);
                                        const tweenDecksStr0 = generateHatchTweenDeckStr(fTweenDecks[0]);
                                        const tweenDecksStr1 = generateHatchTweenDeckStr(fTweenDecks[1]);
                                        return (
                                            <div key={`grouppedByCells_${g[0]}_${vIndex}`} className='row'>
                                                {
                                                    Object.keys(fHolds).length ?
                                                        <div className='col-xs-4'>
                                                            <p><b>Holds: </b> L: {fHolds.l}, B: {fHolds.b}, H: {fHolds.h}</p>
                                                        </div>
                                                        : null
                                                }
                                                <div className='col-xs-4'>
                                                    {
                                                        hatchStr0 &&
                                                        <p><b>Hatches: </b>{hatchStr0}</p>
                                                    }
                                                    {
                                                        hatchStr1 &&
                                                        <p><b>Hatches: </b>{hatchStr1}</p>
                                                    }
                                                </div>
                                                <div className='col-xs-4'>
                                                    {
                                                        tweenDecksStr0 &&
                                                        <p><b>TweenDecks: </b>{tweenDecksStr0}</p>
                                                    }
                                                    {
                                                        tweenDecksStr1 &&
                                                        <p><b>TweenDecks: </b>{tweenDecksStr1}</p>
                                                    }

                                                </div>
                                            </div>
                                        );
                                    }) }
                                </div>
                                <div className='col-xs-5'>
                                    { values.map(v => (
                                        <p style={{ display: 'inline-block' }}>
                                            <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                        </p>
                                    )) }
                                </div>
                                <div className='col-xs-1' style={{ padding: 0 }}>
                                    <ControlButtons 
                                        type='grouppedByCells'
                                        size={sizes && sizes.grouppedByCells[g[0]][index]}
                                        emailIds={values.map(v => v.emailId)}
                                        sizes={sizes}
                                        index={index}
                                        accept={accept}
                                        reject={reject}
                                        transfer={transferOne}
                                        addToMultiTransfer={addToMultiTransfer}
                                        shouldShowApproveReject={shouldShowApproveReject}
                                    />
                                </div>
                            </div>
                        );
                    })
                }
                </div>
                ), 
            });
        }

        if (grouppedByFlags && Object.keys(grouppedByFlags).length) {
            collapsesData.push({
                head: sizesMap.grouppedByFlags,
                body: generateCollapseBody({
                    key: 'grouppedByFlags',
                    group: grouppedByFlags,
                    type: 'object',
                    namesMap: basicNamesFieldsMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }

        if (grouppedByRegisterClass && Object.keys(grouppedByRegisterClass).length) {
            collapsesData.push({
                head: sizesMap.grouppedByRegisterClass,
                body: generateCollapseBody({
                    key: 'grouppedByRegisterClass',
                    group: grouppedByRegisterClass,
                    type: 'object',
                    namesMap: registerClassFieldsMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }

        if (grouppedByPIClub && Object.keys(grouppedByPIClub).length) {
            collapsesData.push({
                head: sizesMap.grouppedByPIClub,
                body: generateCollapseBody({
                    key: 'grouppedByPIClub',
                    group: grouppedByPIClub,
                    type: 'object',
                    namesMap: basicNamesFieldsMap,
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer, shouldShowApproveReject }),
            });
        }
    
        return collapsesData;
    }

    return (
        <React.Fragment>
            {
                collapses.map((c, i) => {
                    return (
                        <CollapseBody 
                            key={`c_${i}`}
                            head={c.head}
                            body={c.body}
                            maxHeight='300px'
                        />
                    );
                })
            }
        </React.Fragment>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(Collapses);

/**
 * @param {{ 
    *      type: 'object'|'array'|'string', 
    *      key: string, 
    *      nameValue?: {name: string, value: string}[], 
    *      group: any,
    *      namesMap?: any }} opts
    */
function generateCollapseBody(
    opts, sizes, accept, reject, transferOne, statuses = {},
    sideEffects = {},
) {
    const { 
        type, key, group, nameValue, namesMap,
    } = opts;
    let valueFieldName = '';
    let keep_id = false;

    switch (type) {
    case 'string':
        return (
            <div> { Object.entries(group).map((g, index) => {
                const value = g[1];
                return (
                    <div key={`${key}_${g[0]}_${index}`} className='row'>
                        <div key={`${key}_${g[0]}_${index}`} className='col-xs-6' style={statuses.typeByConstruction && { opacity: 0.5 }}>
                            { nameValue.map((nv, nvIndex) => {
                                return (
                                    <p key={`${nv.name}${nvIndex}`}><b>{nv.name}:</b> { value[0][nv.value].value + '' }</p>
                                );
                            }) }
                        </div>
                        <div className='col-xs-5'>
                            { value.map(v => (
                                <p key={v.emailId} style={{ display: 'inline-block' }}>
                                    <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                </p>
                            )) }
                        </div>
                        <div className='col-xs-1' style={{ padding: 0 }}>
                            <ControlButtons 
                                type={key}
                                size={sizes && sizes[key][g[0]][index]}
                                emailIds={value.map(v => v.emailId)}
                                index={index}
                                accept={accept}
                                reject={reject}
                                transfer={transferOne}
                                addToMultiTransfer={sideEffects.addToMultiTransfer}
                                shouldShowApproveReject={sideEffects.shouldShowApproveReject}
                            />
                        </div>
                    </div>
                );
            }) } 
            </div>
        );
    case 'array':
        if (key === 'grouppedByGears') {
            valueFieldName = 'gearV2';
        } else if (key === 'grouppedByGrabs') {
            valueFieldName = 'grabV2';
        }

        return (
            <div>
                { Object.entries(group).map((g, index) => {
                    const value = g[1];
                    return (
                        <div key={`${key}_${g[0]}`} className='row'>
                            <div className='col-xs-6'>
                                {
                                    nameValue.map(nv => (
                                        <p><b>{nv.name}:</b> { value[0][nv.value] }</p> 
                                    ))
                                }
                            </div>
                            <div className='col-xs-5'>
                                {
                                    value.map(v => (
                                        <p style={{ display: 'inline-block' }}>
                                            <a href={`${window.location.origin}/${v.emailId}`}>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                        </p>
                                    ))
                                }
                            </div>
                            <div className='col-xs-1' style={{ padding: 0 }}>
                                <ControlButtons 
                                    type={key}
                                    size={sizes && {
                                        [valueFieldName]: {
                                            value: sizes[key][g[0]][index],
                                        },
                                    }}
                                    sizes={sizes}
                                    field={g[0]}
                                    emailIds={value.map(v => v.emailId)}
                                    index={index}
                                    accept={accept}
                                    reject={reject}
                                    transfer={transferOne}
                                    addToMultiTransfer={sideEffects.addToMultiTransfer}
                                    shouldShowApproveReject={sideEffects.shouldShowApproveReject}
                                />
                            </div>
                        </div>
                    );
                }) }
            </div>
        );
    case 'object':
        if (key === 'grouppedByRt') {
            valueFieldName = 'rt';
        } else if (key === 'grouppedByDeadWeight') {
            valueFieldName = 'deadWeight';
        } else if (key === 'grouppedByDimensions') {
            valueFieldName = 'dimensions';
        } else if (key === 'grouppedByHatches') {
            valueFieldName = 'hatches';
        } else if (key === 'grouppedByHolds') {
            valueFieldName = 'holds';
        } else if (key === 'grouppedByCapacityV2') {
            valueFieldName = 'capacityV2';
        } else if (key === 'grouppedByFlags') {
            valueFieldName = 'flag';
            keep_id = true;
        } else if (key === 'grouppedByRegisterClass') {
            valueFieldName = 'registerClass';
            keep_id = true;
        } else if (key === 'grouppedByPIClub') {
            valueFieldName = 'piClub';
            keep_id = true;
        }
        
        return (
            <div>
                {
                    Object.entries(group).map((g, index) => {
                        const value = g[1];
                        return (
                            <div key={`${key}_${g[0]}`} className='row'>
                                <div className='col-xs-6'>
                                    <p>{
                                        Object.entries(_.omit(value[0][valueFieldName].value, ['_id'])).map(d => (
                                            <span key={`${d[0]}_${d[1]}`}>
                                                <b>{namesMap[d[0]]}: </b>
                                                {d[1] + ''}&nbsp;&nbsp;&nbsp;
                                            </span>
                                        ))
                                    }
                                    </p>
                                </div>
                                <div className='col-xs-5'>
                                    {
                                        value.map(v => (
                                            <p style={{ display: 'inline-block' }}>
                                                <a href={`${window.location.origin}/${v.emailId}`} target='_blank'>{v.emailId}</a>&nbsp;&nbsp;&nbsp;
                                            </p>
                                        ))
                                    }
                                </div>
                                <div className='col-xs-1' style={{ padding: 0 }}>
                                    <ControlButtons 
                                        type={key}
                                        size={sizes && sizes[`${key}`][g[0]][0]}
                                        emailIds={value.map(v => v.emailId)}
                                        index={index}
                                        accept={accept}
                                        reject={reject}
                                        transfer={transferOne}
                                        keep_id={keep_id}
                                        addToMultiTransfer={sideEffects.addToMultiTransfer}
                                        shouldShowApproveReject={sideEffects.shouldShowApproveReject}
                                    />
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Collapses.jsx